'use strict';

var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"](function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.grey[200],
      display: 'inline-block',
      padding: '2px 8px',
      borderWidth: 1,
      borderStyle: 'hidden',
      borderRadius: '10px',
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 500
    }
  };
});

var PromoChip = function PromoChip(_ref) {
  var label = _ref.label;

  var _useStyles = useStyles(),
      root = _useStyles.root;

  return React__default["default"].createElement("span", {
    className: root
  }, label);
};

module.exports = PromoChip;
